import React, { useState } from 'react'
import Button from '@mui/material/Button'
import OnlinePredictionIcon from '@mui/icons-material/OnlinePrediction'
import useUpdatesSubscription from '../../../hooks/useUpdatesSubscription'
import Tooltip from '@mui/material/Tooltip'
import Box from '@mui/system/Box'
import { Stack } from '@mui/material'

export const SubscriptionButton = () => {
    const [isLoading, setIsLoading] = useState(false)
    const { isConnected, isSubscribed, subscribToUpdates } = useUpdatesSubscription()

    const handleClick = () => {
        setIsLoading(true)

        subscribToUpdates()
            .then(() => setIsLoading(false))
            .catch((err) => {
                console.error(err)
                setIsLoading(false)
            })
    }

    const description = !isSubscribed
        ? 'Prenumerera för att få en notis när det finns ett nytt pressmeddelande.'
        : isConnected
          ? 'Ansluten. Sidan kommer automatiskt ladda om när det finns ett nytt pressmeddelande.'
          : 'Ansluter...'

    return (
        <Stack direction={'row'} justifyContent={'end'}>
            <Stack>
                <Box sx={{ pr: 2, pt: 1 }}>
                    <Tooltip title={description}>
                        <OnlinePredictionIcon sx={{ color: isConnected ? 'green' : isSubscribed ? 'orange' : 'red' }} />
                    </Tooltip>
                </Box>
            </Stack>

            <Button disabled onClick={handleClick} loading={isLoading} variant='outlined'>
                {!isSubscribed && 'Prenumerera'}
                {isSubscribed && 'Du prenumererar'}
            </Button>
        </Stack>
    )
}
